import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueRouter from 'vue-router'
import router from './router/index'
import vco from 'v-click-outside'
import VueSweetalert2 from 'vue-sweetalert2'

import '../src/design/app.scss'

import store from '@/state/store'

import App from './App.vue'

import i18n from './i18n'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/id'

import GmapCluster from 'vue2-google-maps/src/components/cluster'

import VuejsDialog from 'vuejs-dialog'
// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

import Toast from 'vue-toastification'
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css'

import { client } from '@/services/apolloclient'
import VueApollo from 'vue-apollo'

import mixpanel from 'mixpanel-browser';
mixpanel.init(process.env.VUE_APP_MIX_PANEL_TOKEN, { debug: process.env.VUE_APP_MIX_PANEL_DEBUG });

Vue.use(Toast)

Vue.use(VueRouter)
const VueScrollTo = require('vue-scrollto')
Vue.use(vco)
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2)
Vue.component('v-select', vSelect)
Vue.use(DatePicker)
Vue.component('GmapCluster', GmapCluster)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
    libraries: 'places,geometry,drawing',
    place: 'geometry,drawing'
  },
  installComponents: true
})

// Tell Vue to install the plugin.
Vue.use(VuejsDialog, {
  html: false,
  loader: true,
  okText: 'Ya',
  cancelText: 'Tidak',
  animation: 'bounce',
  backdropClose: true
})
Vue.use(VueApollo)
const apolloProvider = new VueApollo({
  defaultClient: client
})

import './registerServiceWorker'

import { initRemoteConfig } from './services/flags';

initRemoteConfig();

new Vue({
  router,
  store,
  i18n,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
